import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useCompleteUserSetup } from '../hooks/completeUserSetup';
import styles from '../pages/UserPreferences.module.css';

const MealPreferencesStep = ({ onSave, initialValues = {} }) => {
    const { pgUserId } = useAuth();
    const { completeUserSetup } = useCompleteUserSetup();
    
    const [preferences, setPreferences] = useState({
        preferred_number_of_breakfast_meals:  0, //initialValues.preferred_number_of_breakfast_meals || 0,
        preferred_number_of_lunch_meals: 0, //initialValues.preferred_number_of_lunch_meals || 0,
        preferred_number_of_dinner_meals: initialValues.preferred_number_of_dinner_meals || 3,
        preferred_breakfast_serving_size: 0, //initialValues.preferred_breakfast_serving_size || 0,
        preferred_lunch_serving_size: 0, //initialValues.preferred_lunch_serving_size || 0,
        preferred_dinner_serving_size: initialValues.preferred_dinner_serving_size || 2
    });

    const handleChange = (field, value) => {
        setPreferences(prev => ({
            ...prev,
            [field]: parseInt(value, 10)
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // alert("about to send the following preferences: " + JSON.stringify(preferences));
        completeUserSetup(preferences, pgUserId);
        onSave(preferences);
    };

    return (
        <div className="preference-step">
            <h2>How many meals do you want to cook each week?</h2>
            <p>Set your weekly meal count and serving size so AutoChef can plan the right amount for you.</p>
            
            <form onSubmit={handleSubmit}>
                <div className={styles.mealPlanCardsRow}>
                    {/* <div className={styles.mealPlanCard}>
                        <div className={styles.mealPlanTitle}><span className={styles.mealPlanIcon}>🍳</span>Breakfast</div>
                        <div className={styles.mealPlanLabel}>Meals per week:</div>
                        <div className={styles.segmentedControl}>
                            {[0,1,2,3,4,5,6,7].map((value) => (
                                <button
                                    key={value}
                                    type="button"
                                    className={
                                        styles.segmentedOption +
                                        (preferences.preferred_number_of_breakfast_meals === value ? ' ' + styles.segmentedOptionSelected : '')
                                    }
                                    onClick={() => handleChange('preferred_number_of_breakfast_meals', value)}
                                >
                                    {value}
                                </button>
                            ))}
                        </div>
                        <div className={styles.mealPlanLabel}>Serving size:</div>
                        <div className={styles.segmentedControl}>
                            {[1,2,3,4,5,6,7,8].map((value) => (
                                <button
                                    key={value}
                                    type="button"
                                    className={
                                        styles.segmentedOption +
                                        (preferences.preferred_breakfast_serving_size === value ? ' ' + styles.segmentedOptionSelected : '')
                                    }
                                    onClick={() => handleChange('preferred_breakfast_serving_size', value)}
                                >
                                    {value}
                                </button>
                            ))}
                        </div>
                    </div> */}

                    {/* <div className={styles.mealPlanCard}>
                        <div className={styles.mealPlanTitle}><span className={styles.mealPlanIcon}>🥪</span>Lunch</div>
                        <div className={styles.mealPlanLabel}>Meals per week:</div>
                        <div className={styles.segmentedControl}>
                            {[0,1,2,3,4,5,6,7].map((value) => (
                                <button
                                    key={value}
                                    type="button"
                                    className={
                                        styles.segmentedOption +
                                        (preferences.preferred_number_of_lunch_meals === value ? ' ' + styles.segmentedOptionSelected : '')
                                    }
                                    onClick={() => handleChange('preferred_number_of_lunch_meals', value)}
                                >
                                    {value}
                                </button>
                            ))}
                        </div>
                        <div className={styles.mealPlanLabel}>Serving size:</div>
                        <div className={styles.segmentedControl}>
                            {[1,2,3,4,5,6,7,8].map((value) => (
                                <button
                                    key={value}
                                    type="button"
                                    className={
                                        styles.segmentedOption +
                                        (preferences.preferred_lunch_serving_size === value ? ' ' + styles.segmentedOptionSelected : '')
                                    }
                                    onClick={() => handleChange('preferred_lunch_serving_size', value)}
                                >
                                    {value}
                                </button>
                            ))}
                        </div>
                    </div> */}

                    <div className={styles.mealPlanCard}>
                        {/* <div className={styles.mealPlanTitle}><span className={styles.mealPlanIcon}>🍽️</span>Dinner</div> */}
                        <div className={styles.mealPlanLabel}>Meals per week</div>
                        <div className={`${styles.segmentedControl} ${styles.segmentedControl7}`}>
                            {[1,2,3,4,5,6,7].map((value) => (
                                <button
                                    key={value}
                                    type="button"
                                    className={
                                        styles.segmentedOption +
                                        (preferences.preferred_number_of_dinner_meals === value ? ' ' + styles.segmentedOptionSelected : '')
                                    }
                                    onClick={() => handleChange('preferred_number_of_dinner_meals', value)}
                                >
                                    {value}
                                </button>
                            ))}
                        </div>
                        <div className={styles.mealPlanLabel}>Serving size</div>
                        <div className={styles.segmentedControl}>
                            {[1,2,3,4,5,6,7,8].map((value) => (
                                <button
                                    key={value}
                                    type="button"
                                    className={
                                        styles.segmentedOption +
                                        (preferences.preferred_dinner_serving_size === value ? ' ' + styles.segmentedOptionSelected : '')
                                    }
                                    onClick={() => handleChange('preferred_dinner_serving_size', value)}
                                >
                                    {value}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
                
                <div className="d-flex justify-content-between">
                    <button type="button" className="btn btn-secondary" onClick={() => onSave(null, true)}>Back</button>
                    <button type="submit" className="btn btn-primary">Generate Meals</button>
                </div>
            </form>
        </div>
    );
};

export default MealPreferencesStep; 